import { DriverType } from './DriverInfo';
import { loadComponentInSourcelessIframeInternal } from './Iframe-sourceless/Outside/loadComponentInSourcelessIframeInternal';
/**
 * Loads a component in a sourceless iframe, given appropriate information and configuration.
 * Failure to load will result in promise rejection with information
 * about the error.
 * By default we will use the SPO driver, unless a driverImplementation is passed into the hostConfig.
 * @param props The information and configuration for your component
 */
export function loadComponentInSourcelessIframe(props) {
    const { dependencySynthesizer, hostContext, containerRequest, preCheckInfo, options, config, iframeHostingElement } = props;
    // To keep backwards compatibility for inside the iframe, we will construct the driverInfo even if
    // the props version of the function is called.
    const driverInfo = {
        type: config.driverImplementationOverride ? DriverType.Custom : DriverType.SPO,
        documentUrl: containerRequest.url,
        headers: containerRequest.headers,
        containerCodeHint: preCheckInfo.codeDetailsHint,
        preconnectDomains: preCheckInfo.criticalBootDomains,
        componentId: '/'
    };
    // The moment we should consider the start of office-web-host execution, which is used for end to end performance analysis.
    const bootstrapperStartTime = Date.now();
    return loadComponentInSourcelessIframeInternal({
        initializeConfig: {
            type: 'Load',
            driverInfo
        },
        iframeHostingElement,
        dependencySynthesizer,
        hostContext,
        config,
        options,
        additionalInfo: {
            bootstrapperStartTime
        }
    });
}
// cspell:ignore bootstrapper
//# sourceMappingURL=loadComponentInSourcelessIframe.js.map